const { isEmpty } = require('lodash');

const { entries } = Object;

const packageTypes = {
  normal: { label: '宅配', },
  neko: { label: 'ネコポス', },
};

const statuses = {
  initial: { label: '未着手', color: '', },
  picking: { label: '作業中', color: 'warning', },
  picked: { label: '作業済み', color: 'success', },
  pending: { label: '保留中', color: 'secondary', },
  waitingToMulti: { label: '複数待ち', color: 'secondary', },
};

module.exports = {
  fields: () => {
    return {
      id: {
        label: 'ID',
        type: 'string',
        validations: {
          required: v => !isEmpty(v),
        },
      },
      productName: {
        label: '商品名',
        type: 'string',
        validations: {
          required: v => !isEmpty(v),
        },
      },
      packageType: {
        type: 'select',
        label: '梱包種別',
        options: entries(packageTypes).map(([k, _]) => ({ label: _.label, value: k })),
        validations: {
          required: v => !isEmpty(v),
        },
        initialValue: 'normal',
      },
      free1: {
        label: 'オプション1',
        type: 'string',
      },
      free2: {
        label: 'オプション2',
        type: 'string',
      },
      status: {
        type: 'select',
        label: '状態',
        validations: {
          required: v => !isEmpty(v),
        },
        options: entries(statuses).map(([k, _]) => ({ label: _.label, value: k })),
        initialValue: 'initial',
      },
    };
  },
  pendingFields: () => {
    return {
      pendingNote: {
        type: 'text',
        label: '保留メモ',
      },
    };
  },
  statuses,
  packageTypes,
};
